module.exports = __webpack_public_path__ + "img/pdd.d8b3f09c.png";